module.exports = __webpack_public_path__ + "static/media/48_A.06adfa24.png";